import { getDefaultApiKeySelector, setDefaultApiKey } from "../reducers/apiKeyReducer";
import { useAppAction, useAppSelector } from "./redux";

export const useSetDefaultApiKey = () => {
  return useAppAction(setDefaultApiKey);
};

export const useDefaultApiKey = () => {
  return useAppSelector(getDefaultApiKeySelector);
};
